import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { AlertIcon } from '../../assets/imageAssets';
import { closeModal, openModals } from "../../redux/modal.slice";
import { useCancelPaymentMutation, usePausePaymentMutation } from '../../api/mutations/payment.query';
import ModalsEnum from '../../enums/modal.enum';
import Loader from '../../components/Loader';
import { useQueryClient } from '@tanstack/react-query';

const ConfirmCancelationModal = ({modalData}) => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const user = useSelector((state) => state.me.data);
    const { mutate, isPending } = useCancelPaymentMutation();
    const premiumEnd = user?.user_premium_status?.premium_access_until
        ? new Date(user.user_premium_status.premium_access_until).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
        : null;

    const handleClose = () => {
        dispatch(closeModal());
    }

    const handleConfirmCancelation = () => {
        mutate(undefined, {
            onSuccess: () => {
                queryClient.invalidateQueries(['user-info']);
                dispatch(closeModal());
                dispatch(
                    openModals({
                        modalIds: [ModalsEnum.SUBSCRIPTION_CANCELED_MODAL],
                        modalData: [
                            {
                                className: 'small-centered-modal',
                            }
                        ]
                    })
                );
            },
        });
    }

    return (
        <>
            <div className="modal-body">
                <div className='icon error'>
                    <img src={AlertIcon} alt="Alert Icon" />
                </div>
                <h2 className='mb-8'>Confirm Cancelation</h2>
                <p className='mb-20'>Your subscription will remain active until <strong>{premiumEnd || 'N/A'}</strong>. You won't be charged  again after that date.</p>
                <p className='mb-24'>Are you sure you want to cancel?</p>
                <button className='primary-button mb-12' onClick={handleConfirmCancelation}>
                    Confirm Cancelation
                </button>
                <button className='outline-button' onClick={handleClose}>Close</button>
            </div>
            {isPending && <Loader />}
        </>
    );
}

export default ConfirmCancelationModal;